import Dashboard from './screens/Dashboard/Dashboard';
import Login from './screens/Login/Login'

import {Route, Routes, useNavigate} from 'react-router-dom' 
import AccountReview from './screens/AccountManagement/AccountReview';
import Enrollment from './screens/Enrollment/Enrollment';
import PrivateRoute from './util/PrivateRoute';
import { useState } from 'react';
import Resources from './screens/Resources/Resources';

function App() {

  const [isAuthenticated, setAuthenticated] = useState(false)

  const navigation=useNavigate()

  return (
    <div className="container">
      <Routes>
        <Route path="/" element={<Login navigator={navigation}  setAuth={setAuthenticated} />} />
        <Route path="/Login" element={<Login navigator={navigation}  setAuth={setAuthenticated} />} /> 

          <Route path='/Dashboard' element={
            <PrivateRoute isAuthenticated={isAuthenticated}>
              <Dashboard navigator={navigation}/>
            </PrivateRoute>
          }/>
        
          <Route path='/AccountReview' element={
            <PrivateRoute isAuthenticated={isAuthenticated}>
              <AccountReview navigator={navigation}/>
            </PrivateRoute>
          }/>
        
          <Route path='/Enrollment' element={
            <PrivateRoute isAuthenticated={isAuthenticated}>
              <Enrollment navigator={navigation}/>
            </PrivateRoute>
          }/> 
          <Route path='/Resources' element={
            <PrivateRoute isAuthenticated={isAuthenticated}>
              <Resources navigator={navigation}/>
            </PrivateRoute>
          }/> 
      </Routes>
    </div>
  );
}

export default App;
